import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for validationScheme in signup procedure */

const RiskAssessmentSchema = Yup.object({
  name: Yup.string().required('Template name is required'),
  //   sections: Yup.array().of(
  //     Yup.object({
  //       title: Yup.string().required('Section title required'),
  //       subsections: Yup.array().of(
  //         Yup.object({
  //           title: Yup.string().required('Subsection title required'),
  //           questions: Yup.array().of(
  //             Yup.object({
  //               questionText: Yup.string().required('Question required'),
  //               type: Yup.string().required('Type required'),
  //             })
  //           ),
  //         })
  //       ),
  //     })
  //   ),
  sections: Yup.array()
    .of(
      Yup.object().shape({
        title: Yup.string().trim().required('Section title is required'),
        subsections: Yup.array().of(
          Yup.object().shape({
            title: Yup.string().trim().required('Subsection title is required'),
          })
        ),
      })
    )
    .min(1, 'At least one section is required'),
});

export { RiskAssessmentSchema };
